import apiService from '@/services/apiService';

class DashboardService {
  static create() {
    return new DashboardService();
  }

  async getPromotedResources() {
    const response = await apiService.get('resources/promoted');
    return response.data;
  }

  async getClub(clubId) {
    const response = await apiService.get(`clubs/${clubId}`);
    return response.data;
  }

  async getDashboardPermissions(clubId) {
    const response = await apiService.get(`clubs/${clubId}/dashboard_permissions`);
    return response.data;
  }
}

export default DashboardService;
